import React from 'react'
import clsx from 'clsx'

import { Avatar } from '@wartek-id/avatar'
import { Text } from '@wartek-id/text'
import { Icon } from '@wartek-id/icon'

import { timeAgo } from 'utils/datetime'
import { nl2br, stripHTMLTags } from 'utils/text'

interface FeedbackCardProps {
  authorName: string
  authorId: string
  authorEmail: string
  createdAt: string
  avatarUrl: string
  content: string
  topikId: string
  topikName: string
  aksiNyataId: string | number
}

const FeedbackCard = ({
  authorEmail,
  avatarUrl,
  authorName,
  createdAt,
  content,
}: FeedbackCardProps) => {
  const feedbackRef = React.useRef<HTMLDivElement>(null)
  const [showMore, setShowMore] = React.useState(false)
  const [expanded, setExpanded] = React.useState(false)

  React.useLayoutEffect(() => {
    if (feedbackRef.current?.clientHeight < feedbackRef.current?.scrollHeight) {
      setShowMore(true)
    }
  }, [])

  return (
    <div className="flex mb-6">
      <Avatar
        className="flex-shrink-0 flex-grow-0"
        src={avatarUrl}
        name={authorName}
        alt={authorName}
      />
      <div className="ml-4 overflow-auto">
        <Text className="mb-2" as="div" color="subdued" variant="helper">
          {!!authorName && authorName.length > 0 ? authorName : authorEmail}
          &nbsp;&#183;&nbsp;{timeAgo(createdAt)}
        </Text>
        <div>
          <Text
            ref={feedbackRef}
            className={clsx('break-words', !expanded && 'line-clamp-5')}
            dangerouslySetInnerHTML={{
              __html: nl2br(stripHTMLTags(content)),
            }}
          />
          {showMore && (
            <button
              className="flex items-center"
              onClick={() => setExpanded((old) => !old)}
            >
              <Text variant="body-sm" className="underline">
                <strong>{expanded ? 'Ringkas' : 'Selengkapnya'}</strong>
              </Text>
              <Icon
                as="i"
                color="default"
                fontSize="default"
                className={clsx(
                  expanded ? 'transform rotate-180 origin-center' : ''
                )}
              >
                keyboard_arrow_down_icon
              </Icon>
            </button>
          )}
        </div>
      </div>
    </div>
  )
}

export default FeedbackCard
